import { useQuery } from "react-query";
import { axiosInstance } from "../../config/axios";

interface Params {
    taxNumber: string;
    [key: string]: any;
}

interface MerchantGroup {
    id: string;
    name: string;
    [key: string]: any;
}

interface Options {
    enabled?: boolean;
    [key: string]: any;
}

export const useGetMerchantGroupByTaxNumber = (
    params: Params,
    options: Options = {}
) => {
    return useQuery<MerchantGroup[], unknown>(
        ["GetMerchantGroupByTaxNumber", params],
        async () => {
            const { data } = await axiosInstance.post<MerchantGroup[]>("/Merchant/GroupByTaxNumber", params);
            return data;
        },
        { ...options }
    );
};
